export class Path {

  public static readonly LOGIN = {
    GET_USER_DETAILS: "boc-login/get"
  };

  public static readonly ANNOUNCEMENT = {
    GET_LIST: "boc-announcement/list",
    GET_DETAILS: "boc-announcement/get",
    INSERT: "boc-announcement/insert",
    UPDATE: "boc-announcement/update"
  };

  public static readonly BOOKING_ADJUSTMENT = {
    GET_LIST: "boc-adjustment/list",
    GET_DETAILS: "boc-adjustment/get",
    // INSERT: "announcement/insert",
    UPDATE: "boc-adjustment/untag-onhold",
    GET_CONSOLIDATOR_LIST: "boc-adjustment/filter-consolidator-list",
    GET_DECONSOLIDATOR_LIST: "boc-adjustment/filter-deconsolidator-list"
  };

  public static readonly AIR_BOOKING_ADJUSTMENT = {
    GET_LIST: "boc-airbk-adjustment/list",
    GET_DETAILS: "boc-airbk-adjustment/get",
    UPDATE: "boc-airbk-adjustment/untag-onhold"
  }

  public static readonly WEB_USER = {
    GET_LIST: "web-user-boc/list",
    GET_DETAILS: "web-user-boc/get",
    INSERT: "web-user-boc/insert",
    UPDATE: "web-user-boc/update",
    DELETE: "web-user-boc/delete",
    DOWNLOAD_LIST: "boc-web-user-dn/task-runner",
    GET_ROLE_LIST: ""
  };

  public static readonly SECURITY_MATRIX = {
    GET_ROLE_MATRIX: "web-role-matrix-boc/list",
    UPDATE_ROLE: "web-role-matrix-boc/update",
    GET_MODULE_GROUP: "web-module-group-boc/list"
  };

  public static readonly CONTAINER_SIZE = {
    GET_LIST: "boc-container-size/list",
    GET_DETAILS: "boc-container-size/get",
    INSERT: "boc-container-size/insert",
    UPDATE: "boc-container-size/update",
    DOWNLOAD_LIST: "boc-consize-dn/task-runner"
  };

  public static readonly CONSOLIDATOR = {
    GET_LIST: "boc-consolidator/list",
    GET_DETAILS: "boc-consolidator/get",
    INSERT: "boc-consolidator/insert",
    UPDATE: "boc-consolidator/update",
    DOWNLOAD_LIST: "boc-cons-dn/task-runner"
  };

  public static readonly DECONSOLIDATOR = {
    GET_LIST: "boc-deconsolidator/list",
    GET_DETAILS: "boc-deconsolidator/get?id",
    INSERT: "boc-deconsolidator/insert",
    UPDATE: "boc-deconsolidator/update",
    DOWNLOAD_LIST: "boc-decons-dn/task-runner"
  };

  public static readonly CONSOLIDATOR_DECONSOLIDATOR_MAPPING = {
    GET_LIST: "boc-cons-decons-map/list",
    GET_DETAILS: "boc-cons-decons-map/get",
    INSERT: "boc-cons-decons-map/insert",
    UPDATE: "boc-cons-decons-map/update"
  };

  public static readonly PORT = {
    GET_LIST: "boc-port/list",
    GET_DETAILS: "boc-port/get",
    INSERT: "boc-port/insert",
    UPDATE: "boc-port/update",
    DOWNLOAD_LIST: "boc-port-download/task-runner"
  };

  public static readonly WEB_USER_POD_MAPPING = {
    GET_LIST: "web-user-boc-pod-map/list",
    GET_DETAILS: "web-user-boc-pod-map/get",
    INSERT: "web-user-boc-pod-map/insert",
    UPDATE: "web-user-boc-pod-map/update",
    GET_WEB_USER_LIST: "web-user-boc/list",
    GET_POD_LIST: "boc-port/list"
  };

  public static readonly MANIFEST = {
    GET_LIST: "boc-manifest-detail/list",
    GET_DETAILS: "boc-manifest-detail/get",
    UPDATE: "boc-manifest-detail/update",
    GET_FILTER_CONSOLIDATOR_LIST: "boc-manifest-detail/filter-consolidator-list",
    GET_FILTER_DECONSOLIDATOR_LIST: "boc-manifest-detail/filter-deconsolidator-list",
    GET_FILTER_BOOKING_STATUS_LIST: "boc-manifest-detail/filter-status-list",
    DOWNLOAD_LIST: "boc-manifest-dtl-dn/task-runner"
  };

  public static readonly STRIPPING_TALLY_SHEET = {
    GET_LIST: "boc-strip-tsheet/list",
    GET_DETAIL: "boc-strip-tsheet/print-stripping"
  };

  public static readonly IMAGE_DOWNLOAD = {
    GET_LIST: "boc-txn-image/list",
    GET_BOOKING_NUMBER_LIST: "boc-manifest-detail/list",
  };

  public static readonly GENERIC = {
    GET_ROLE_LIST: "web-role-boc/list",
    COUNTRY: "boc-country/list"
  };

  public static readonly DASHBOARD = {
    GET_LAST_UPDATED_DATE: "boc-rpt-util-sum/get-last-summary-date",

    GET_OVERSTAY_BY_PORT_CHART: "boc-rpt-overstay-dash/get-by-port-of-discharge",
    GET_OVERSTAY_BY_PORT_DETAILS: "boc-report-overstay/task-runner",
    GET_OVERSTAY_BY_DAYS_CHART: "boc-rpt-overstay-dash/get-by-number-days",
    GET_OVERSTAY_BY_DAYS_DETAILS: "boc-report-overstay/task-runner",
    GET_CONSOLIDATOR_FILTER: "boc-rpt-overstay-fltr/get-consolidators",
    GET_DECONSOLIDATOR_FILTER: "boc-rpt-overstay-fltr/get-deconsolidators",
    GET_POD_FILTER: "boc-rpt-overstay-fltr/get-discharge-ports",

    GET_UNRELEASED_CHART: "boc-rpt-unrel-dash/get-by-number-days",
    GET_UNRELEASED_DETAILS: "boc-report-unreleased/task-runner",
    GET_UNRELEASED_CONSOLIDATOR_FILTER: "boc-rpt-unrel-fltr/get-consolidators",
    GET_UNRELEASED_DECONSOLIDATOR_FILTER: "boc-rpt-unrel-fltr/get-deconsolidators",
    GET_UNRELEASED_MASTER_BL_FILTER: "boc-rpt-unrel-fltr/get-master-bl-numbers",
    GET_UNRELEASED_BOOKING_NUMBER_FILTER: "boc-rpt-unrel-fltr/get-booking-numbers",

    GET_RELEASED_CHART: "boc-rpt-released-dash/get-per-month",
    GET_RELEASED_DETAILS: "boc-report-released/task-runner",
    GET_RELEASED_DECONSOLIDATOR_FILTER: "boc-rpt-released-fltr/get-deconsolidators",
    GET_RELEASED_CONSOLIDATOR_FILTER: "boc-rpt-released-fltr/get-consolidators",
    GET_RELEASED_MASTER_BL_FILTER: "boc-rpt-released-fltr/get-master-bl-numbers",
    GET_RELEASED_LOAD_PLAN_FILTER: "boc-rpt-released-fltr/get-loadplan-numbers",
    GET_RELEASED_CONTAINER_FILTER: "boc-rpt-released-fltr/get-container-numbers",
    GET_RELEASED_BOOKING_NUMBER_FILTER: "boc-rpt-released-fltr/get-booking-numbers",
  }

  public static readonly OVERSTAY_REPORT = {
    GET_BOOKING_NUMBER_FILTER: "boc-rpt-overstay-fltr/get-booking-numbers",
    GET_POD_FILTER: "boc-rpt-overstay-fltr/get-discharge-ports",
    GET_REPORT: "boc-report-overstay/task-runner"
  }

  public static readonly CARGO_TRACKING_SUMMARY_REPORT = {
    GET_DECONSOLIDATOR_FILTER: "boc-rpt-ctrsum-fltr/get-deconsolidators",
    GET_CONSOLIDATOR_FILTER: "boc-rpt-ctrsum-fltr/get-consolidators",
    GET_MASTER_BL_NUMBER_FILTER: "boc-rpt-ctrsum-fltr/get-master-bl-numbers",
    GET_PORT_OF_LOADING_FILTER: "boc-rpt-ctrsum-fltr/get-loading-ports",
    GET_CONTAINER_NUMBER_FILTER: "boc-rpt-ctrsum-fltr/get-container-numbers",
    GET_STATUS_FILTER: "boc-rpt-ctrsum-fltr/get-sh-statuses",
    GET_REPORT: "boc-rpt-ctrsum/task-runner"
  }

  public static readonly CARGO_TRACKING_DETAIL_REPORT = {
    GET_DECONSOLIDATOR_FILTER: "boc-rpt-ctrdtl-fltr/get-deconsolidators",
    GET_CONSOLIDATOR_FILTER: "boc-rpt-ctrdtl-fltr/get-consolidators",
    GET_CONTAINER_NUMBER_FILTER: "boc-rpt-ctrdtl-fltr/get-container-numbers",
    GET_BOOKING_NUMBER_FILTER: "boc-rpt-ctrdtl-fltr/get-booking-numbers",
    GET_STATUS_FILTER: "boc-rpt-ctrdtl-fltr/get-statuses",
    GET_REPORT: "boc-report-ctr-detail/task-runner"
  }

  public static readonly PRIVACY_POLICY = {
    GET_PRIVACY_POLICY: "boc-data-privacy/get"
  }

  public static readonly EXAMINER_MODULE = {
    GET_LIST: "boc-airbk-examiner/list",
    GET_BOOKING_DETAILS: "boc-airbk-examiner/get",
    ON_HOLD_BOOKING: "boc-airbk-examiner/onhold",
    APPROVE_BOOKING: "boc-airbk-examiner/approve",
  }

  public static readonly BOOKING = {
    GET_LIST: "boc-booking-list/list",
    GET_DETAILS: "boc-booking-list/get",
    GET_FILTER_BOOKING_STATUS_LIST: "boc-booking-list/filter-status-list",
    DOWNLOAD_LIST: "boc-booking-dl/task-runner"
  }

}